// Base URL
const base_url = "https://api.rawg.io/api/";
// Getting the date
const getCurrentMonth = () => {
  const month = new Date().getMonth() + 1;
  if (month < 10) return `0${month}`;
  else return month;
};
// Getting the day
const getCurrentDay = () => {
  const day = new Date().getDate();
  if (day < 10) return `0${day}`;
  else return day;
};
// Current day/month/year
const currentYear = new Date().getFullYear();
const currentMonth = getCurrentMonth();
const currentDay = getCurrentDay();
const currentDate = `${currentYear}-${currentMonth}-${currentDay}`;
const lastYear = `${currentYear - 1}-${currentMonth}-${currentDay}`;
const nextYear = `${currentYear + 1}-${currentMonth}-${currentDay}`;
// Key
const key  = `&key=${process.env.REACT_APP_RAWG_API_KEY}`;
// popular games
const popular_games = `games?${lastYear},${currentDate}&ordering=-rating&page_size=10${key}`;
const new_games = `games?${lastYear},${currentDate}&ordering=-released&page_size=10${key}`;
const upcoming_games =`games?dates=${currentDate},${nextYear}&ordering=-added&page_size=10${key}`;
export const popularGamesURL = () => `${base_url}${popular_games}`;
export const newGamesURL = () => `${base_url}${new_games}`;
export const upcomingGamesURL = ()=> `${base_url}${upcoming_games}`;
// Game Details
export const gameDetailsURL=(game_id)=> `${base_url}games/${game_id}?${key}`;
// Game Screenshots
export const gameScreenshotURL=(game_id)=> `${base_url}games/${game_id}/screenshots?${key}`;
//Searched Game
export const searchGameURL= (game_name)=>`${base_url}games?search=${game_name}&page_size=10${key}`;